__turbopack_context__.v({
  "downloadButton": "index-module__Qo9hWa__downloadButton",
  "primary": "index-module__Qo9hWa__primary",
  "special": "index-module__Qo9hWa__special",
});
